module.exports = __webpack_public_path__ + "img/splash-v2.0ef1c470.jpg";